import axios from 'axios'
import router from '../router'
import i18n from '@/utils/locale'
import { ElMessage, ElMessageBox } from 'element-plus'
import nProgress from 'nprogress'
import 'nprogress/nprogress.css'

// 是否已提示消息弹框
let messageInstance = null

// 请求地址
const serverUrl = window.options.serverUrl
axios.defaults.baseURL = serverUrl
axios.defaults.withCredentials = true

// 请求拦截器
axios.interceptors.request.use(
  function (config) {
    // 隐藏加载状态
    const conditions = ['employee/import-progress', '/employee/verify-designated', 'wayleave/query-wayleave-employee-sync']
    if (!conditions.includes(config.url)) {
      // 显示顶部加载动画
      nProgress.start()
    }
    // 校验请求参数
    if (!checkRequest(config.data)) {
      showMessage(i18n.global.t('public.parameterWrong'), 'custom_checkRequest')
      return Promise.reject(new Error('custom_checkRequest'))
    }
    return config
  },
  function (error) {
    // 去掉顶部加载动画
    nProgress.done()
    if (error.message === 'custom_checkRequest') {
      showMessage(i18n.global.t('public.parameterWrong'))
    } else {
      // 错误：请求响应操作超时
      showMessage(i18n.global.t('public.requestResponseError'))
    }
    return Promise.reject(error)
  }
)

// 响应拦截器
axios.interceptors.response.use(
  function (response) {
    // 去掉顶部加载动画
    nProgress.done()
    // 判断响应结果
    if (response.data.resultCode === 99) {
      // 身份过期
      window.sessionStorage.clear()
      showMessage(i18n.global.t('public.lossSession'), 'custom_sessionExpired')
      return
    } else if (response.data.resultCode === 98) {
      // 无权限
      showMessage(i18n.global.t('public.noPermission'))
      return
    } else if (response.data.resultCode === 97) {
      // 操作失败
      showMessage(i18n.global.t('public.operationFailure'))
      return
    }
    return response
  },
  function (error) {
    // 去掉顶部加载动画
    nProgress.done()
    // 是否是自定义参数
    if (error.message !== 'custom_checkRequest') {
      // 错误：请求响应操作超时
      showMessage(i18n.global.t('public.requestResponseError'))
    }
    return Promise.reject(error)
  }
)

// 校验请求字符串合法性
function checkRequest (obj) {
  for (const key in obj) {
    if (typeof obj[key] === 'string') {
      if (!checkValueLegitimate(obj[key])) {
        return false
      }
    } else if (typeof obj[key] === 'object') {
      if (!checkRequest(obj[key])) {
        return false
      }
    }
  }
  return true
}

// 校验请求字符串合法性
function checkValueLegitimate (data) {
  // 检查开头或结尾是否有空格/tab
  if (/^\s|\s$/.test(data)) {
    return false
  }
  // 检查字符串前后是否有空格
  if (data.trim() !== data) {
    return false
  }
  return true
}

// 显示消息弹框
function showMessage (message, type) {
  if (messageInstance) {
    // 如果已经存在一个消息提示实例，则先关闭它
    messageInstance.close()
  }
  // 消息内容
  if (type === 'custom_checkRequest') {
    // 请求参数不正确
    messageInstance = ElMessage({ message, type: 'warning' })
  } else if (type === 'custom_sessionExpired') {
    // 身份过期
    const elMessageBox = document.querySelector('.custom_session_message')
    if (elMessageBox === null) {
      ElMessageBox.confirm(i18n.global.t('public.lossSession'), i18n.global.t('header.systemPrompt'), {
        confirmButtonText: 'OK',
        type: 'warning',
        showClose: false,
        showCancelButton: false,
        closeOnClickModal: false,
        customClass: 'custom_session_message',
        callback: () => {
          router.push('/')
        }
      })
    }
  } else {
    // 显示新的消息提示，并保存该实例
    messageInstance = ElMessage({ message, type: 'error' })
  }
}

// get请求
export const get = (url, params) => {
  return axios.get(url, params)
}
// post请求
export const post = (url, params) => {
  return axios.post(url, params)
}
// 校验请求参数
export const check = (params) => {
  return checkRequest(params)
}
